import { api } from "../../Config/ApiConfig";

export const register = async (userData, captchaToken) => {
    const { data } = await api.post('/auth/register', userData, {
        headers: captchaToken ? { 'turnstile_token': captchaToken } : undefined
    });
    return data;
};